import { Component, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { Ventrncotizacion } from "../veninterfaces/ventrncotizacion";
import { VentrncotizacionService } from "../venservicios/ventrncotizacion.service";

import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { DatePipe } from '@angular/common';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Venenccotizacion } from "../veninterfaces/venenccotizacion";
import { Vendetcotizacion } from "../veninterfaces/vendetcotizacion";
import { isNullOrUndefined } from 'util';



@Component({
  selector: 'app-ventrncotizacion',
  templateUrl: './ventrncotizacion.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class VentrncotizacionComponent implements OnInit {

  hmpConfiguracion: any[];
  indicador: any;

  btnGuardar: boolean;
  btnRegresar: boolean;
  btnBorrar: boolean;
  botonAnular: boolean;
  botonXML: boolean;
  botonReenviarCorreo: boolean;
  botonAsiento: boolean;
  botonPago: boolean;
  botonBuscar: boolean;
  botonVerAsiento: boolean;
  botonAnterior: boolean;
  botonPrimero: boolean;
  botonUltimo: boolean;
  botonSiguiente: boolean;
  barraBotones2: boolean;
  btnNuevo: boolean;
  botonAutorizar: boolean;
  activeIndex: number;
  boolimpdig: boolean;
  boolimpoffset: boolean;
  boolplotter: boolean;
  permisoventrncot: SegMaePermiso
  NUMCOTI;
  TIPDET: string
  GNUCOTG;
  boolcomprobante;

  tabActiva = 0
  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  spin
  //dialogs
  displayDialogBusquedaFast: boolean;
  modo
  constructor(
    public ventrncotizacionService: VentrncotizacionService,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService,
    private permisosService: PermisosService,
    private utilitariosService: UtilitariosService,
    private confirmationService: ConfirmationService,
    private auditoriagral: AuditoriagralService,
    private busqService: InvbusquedaService,
    private messageService: MessageService, private datePipe: DatePipe,
  ) { }

  async  ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;

    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAnular = false;
    this.botonXML = true;
    this.botonReenviarCorreo = true;
    this.botonAsiento = false;
    this.botonVerAsiento = false;
    this.botonBuscar = false;
    this.botonAutorizar = false;
    this.boolimpdig = false;
    this.boolimpoffset = false;
    this.boolplotter = false
    this.ventrncotizacionService.trncotiza[this.indicador] = {}
    this.activeIndex = 0;
    this.modo='bloqueo'
    await Promise.all(
      [await this.getPermisos(),
      await this.getconfiguraciones(),
      await this.getdecimales()]
    );
    await this.crearcotizaciones()
  }
  ngOnDestroy(): void {
    this.confIniciales.instanciasTrnCot--;
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoventrncot = data[0];
        } else {
          this.permisoventrncot = null;
        }
      } else {
        this.permisoventrncot = null;
      }
      return data;
    } catch (e) {
      this.permisoventrncot = null;
      this.messageService.add({
        key: 'ventrncot',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async getconfiguraciones() {
    try {
      const conf = await this.auditoriagral.obtenerConfiguracion1().toPromise()//subscribe((conf) => {
      this.ventrncotizacionService.hmpConfiguracion = conf;
      this.NUMCOTI = this.ventrncotizacionService.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NUMCOTI').CFG_VALOR3
      this.TIPDET = this.ventrncotizacionService.hmpConfiguracion.find(element => element.CFG_CODIGO === 'TIPDET').CFG_VALOR3;
      this.GNUCOTG = this.ventrncotizacionService.hmpConfiguracion.find(element => element.CFG_CODIGO === 'GNUCOTG').CFG_VALOR1;
      //}); 
      if (this.GNUCOTG === 1) {
        this.boolcomprobante=true;
      }else{
        this.boolcomprobante=false;
      }
      return conf
    } catch (error) {
      this.messageService.add({
        key: 'ventrncot',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener la configuración'
      });
    }
  }
  async getdecimales() {
    try {
      const dec = await this.confIniciales.getDecimales('frmPROD_ENCORDPRO').toPromise()//subscribe((dec) => {
      const dec2 = await this.confIniciales.getDecimales('frmVEN_ENCFAC').toPromise()
      if (dec !== null) {
        for (const decimales of dec) {
          if (decimales.NUMDEC_TIPDOC === 'detordpro') {
            if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
              this.ventrncotizacionService.decimalesCantidad = Number(decimales.NUMDEC_NUMDEC);
            } else if (decimales.NUMDEC_CAMPO === 'COSTO') {
              this.ventrncotizacionService.decimalesCosto = Number(decimales.NUMDEC_NUMDEC);
            } else if (decimales.NUMDEC_CAMPO === 'TOTAL') {
              this.ventrncotizacionService.decimalesTotal = Number(decimales.NUMDEC_NUMDEC);
            }
          }
          if (decimales.NUMDEC_TIPDOC === 'encordpro') {
            if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
              this.ventrncotizacionService.decimalesCantEnc = Number(decimales.NUMDEC_NUMDEC);
            }
          }
          // if (decimales.NUMDEC_TIPDOC === 'trncostosind') {
          //   if (decimales.NUMDEC_CAMPO === 'COSTO') {
          //     this.ventrncotizacionService.decimalesCostoind = Number(decimales.NUMDEC_NUMDEC);
          //   }
          // }
        }
      }
      if (dec2 !== null) {
        for (const decimales of dec2) {
          if (decimales.NUMDEC_TIPDOC === 'detfac') {
            if (decimales.NUMDEC_CAMPO === 'PRECIO') {
              this.ventrncotizacionService.decimalesPrecio= Number(decimales.NUMDEC_NUMDEC);
            } else if (decimales.NUMDEC_CAMPO === 'TOTAL') {
              this.ventrncotizacionService.decimalesTOTALFAC = Number(decimales.NUMDEC_NUMDEC);
            } 
          }
          // if (decimales.NUMDEC_TIPDOC === 'trncostosind') {
          //   if (decimales.NUMDEC_CAMPO === 'COSTO') {
          //     this.ventrncotizacionService.decimalesCostoind = Number(decimales.NUMDEC_NUMDEC);
          //   }
          // }
        }
      }
      //});
      return {dec,dec2};
    } catch (error) {
      this.messageService.add({
        key: 'ventrncot',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los decimales'
      });
    }
  }
  async crearcotizaciones() {
    try {

      this.ventrncotizacionService.trncotiza[this.indicador].cotizaciones = []
      for (let i = 1; i <= this.NUMCOTI; i++) {
        const encabezado: Venenccotizacion = {
          TRNCOTIZA_NUMERO: '',
          ENCCOTIZA_NUMERO: i,
          COM_CODIGO: '01',
          ENCCOTIZA_TIRO: '',
          ENCCOTIZA_RETIRO: '',
          ENCCOTIZA_NUMPLACAS: '',
          ENCCOTIZA_MACULATURA: '',
          ENCCOTIZA_TOTREALPRO: '',
          ENCCOTIZA_LARGO: '',
          ENCCOTIZA_ANCHO: '',
          ENCCOTIZA_CANTIDAD: '',
          ENCCOTIZA_FORMULA: '',
          ENCCOTIZA_BODPT: '',
          ENCCOTIZA_BODMP: '',
          ENCCOTIZA_TOTCOSTO: Number(0).toFixed(this.ventrncotizacionService.decimalesCantEnc),
          ENCCOTIZA_PORCEUTIL: Number(0).toFixed(2),
          ENCCOTIZA_UTILIDAD: Number(0).toFixed(2),
          ENCCOTIZA_PRECIOUNI: Number(0).toFixed(this.ventrncotizacionService.decimalesPrecio),
          ENCCOTIZA_PRECIOTOT:  Number(0).toFixed(this.ventrncotizacionService.decimalesTOTALFAC),
          ART_CODIGO: '',
          ENCPED_NUMERO: '',
          detalle: []
        }
        this.ventrncotizacionService.trncotiza[this.indicador].cotizaciones.push(encabezado)
      }
    } catch (error) {
      this.messageService.add({
        key: 'ventrncot',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al crear las cotizaciones'
      });
    }
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisoventrncot.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoventrncot.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'ventrncot',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoventrncot.PERTODO === 1) {
        this.validaguardar();
      } else {
        if (this.permisoventrncot.PERINSERCION === 1) {
          this.validaguardar();
        } else {
          this.messageService.add({
            key: 'ventrncot',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  
  nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.botonAsiento = true;
    this.botonVerAsiento = true;
    this.modo='pendiente'
    const nuvatrncot: Ventrncotizacion = {
      TRNCOTIZA_NUMERO: '',
      TRNCOTIZA_COMPROBANTE: '',
      TRNCOTIZA_FECHAEMISION: new Date(),
      TRNCOTIZA_FECHAENTREGA: new Date(),
      TRNCOTIZA_IMPDIGITAL: '',
      TRNCOTIZA_IMPOFFSET: '',
      TRNCOTIZA_PLOTER: '',
      TRNCOTIZA_ESTADO: '',
      CLI_CODIGO: '',
      VEN_CODIGO: '',
      GRUP_CODIGO: '',
      COM_CODIGO: '01',
      USUIDENTIFICACION: '',
      CLI_NOMBRE: '',
      VEN_NOMBRE: '',
      GRUP_NOMBRE: '',
      cotizaciones: []
    }
    this.ventrncotizacionService.trncotiza[this.indicador] = nuvatrncot
    this.crearcotizaciones()
    document.getElementById('divPrincipal').style.pointerEvents = 'all';
    if (this.GNUCOTG === 1) {
      this.boolcomprobante=true;
      document.getElementById('CLI_CODIGO').focus();
    }else{
      document.getElementById('TRNCOTIZA_COMPROBANTE').focus();
      this.boolcomprobante=false;
    }
  }
  cancelar() {
    if (this.ventrncotizacionService.trncotiza[this.indicador].TRNCOTIZA_NUMERO === '' ||
      isNullOrUndefined(this.ventrncotizacionService.trncotiza[this.indicador].TRNCOTIZA_NUMERO)) {
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      this.botonAnular = false;
      this.botonXML = true;
      this.botonReenviarCorreo = true;
      this.botonAsiento = false;
      this.botonVerAsiento = false;
      this.botonBuscar = false;
      this.botonAutorizar = false;
      this.boolimpdig = false;
      this.boolimpoffset = false;
      this.boolplotter = false
      this.modo='bloqueo'
      this.ventrncotizacionService.trncotiza[this.indicador] = {}
      this.crearcotizaciones();
      document.getElementById('divPrincipal').style.pointerEvents = 'none';
    }
  }
  validaguardar(){
    console.log(this.ventrncotizacionService.trncotiza[this.indicador])
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAnular = false;
    this.ventrncotizacionService.trncotiza[this.indicador].TRNCOTIZA_COMPROBANTE='0000000001'
    this.ventrncotizacionService.trncotiza[this.indicador].TRNCOTIZA_NUMERO='CT000000001'
    this.messageService.add({
      key: 'ventrncot',
      severity: 'success',
      summary: 'Información',
      detail: 'Cotización guardada con éxito'
    });
  }
  changeTabs() {

  }
 
  cambiarFoco(event) {
    let element: any;
    switch (event.target.id) {
      case 'TRNCOTIZA_COMPROBANTE': {
        element = document.getElementById('CLI_CODIGO');
        break;
      }
      case 'CLI_CODIGO': {
        this.abrircliente(event.target.value);
        break;
      }
      case 'VEN_CODIGO': {
        this.abrirvendedor(event.target.value);
        break;
      }
      case 'GRUP_CODIGO': {
        this.abrirgrupo(event.target.value);
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }

  }

  cambio(evento) {

  }
  async abrircliente(parametro) {
    if (parametro === null) {
      parametro = '';
    }
    this.opcionbusqueda = 'cliente';
    this.types = [
      { label: 'Código', value: 'CLI_CODIGO' },
      { label: 'Nombre', value: 'CLI_NOMBRE' },
      { label: 'RucIde', value: 'CLI_RUCIDE' },
      { label: 'Zona', value: 'CLI_ZONA' },
      { label: 'Grupo', value: 'GRU_CODIGO' },
      { label: 'Contacto', value: 'CLI_CONTACTO' },
      { label: 'Placa', value: 'CLI_PLACA' },
      { label: 'NombreC', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', '', ''];
    this.tabla = 'VEN_MAECLIENTE';
    this.where = '';

    if (parametro !== '' && parametro !== undefined && parametro !== null) {
      const eR = await this.ventrncotizacionService.erpBusquedaCliente(this.tabla, this.types[0].value, parametro);
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
          return;
        }
      }
    }
    //this.spin = true;
    this.busqService.busquedaVenMaeCliente3(parametro).subscribe((datos: any[]) => {
      this.spin = true;
      this.arregloCons = datos;
      // this.spin = false;
      this.displayDialogBusquedaFast = true;
      this.spin = false;
    });
  }
  abrirvendedor(parametro) {
    if (parametro === null) {
      parametro = '';
    }
    this.opcionbusqueda = 'vendedor';
    this.types = [
      { label: 'Código', value: 'VEN_CODIGO' },
      { label: 'Nombre', value: 'VEN_NOMBRE' }
    ];
    this.busquedacampos = [parametro, ''];
    this.tabla = 'VEN_MAEVENDEDOR';
    this.where = '';

    this.ventrncotizacionService.erBusquedaVendedor('*', this.tabla, this.types[0].value, parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.ventrncotizacionService.trncotiza[this.indicador].VEN_NOMBRE = eR[0].VEN_NOMBRE;
          document.getElementById('GRUP_CODIGO').focus();
        } else {
          this.spin = true;
          this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.spin = false;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.spin = true;
        this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.spin = false;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  abrirgrupo(parametro) {
    this.opcionbusqueda = 'busquedagrupo';
    this.types = [
      { label: 'Código', value: 'GRUP_CODIGO' },
      { label: 'Nombre', value: 'GRUP_NOMBRE' }
    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'INV_MAEGRUPO';
    this.where = 'GRUP_CODIGOP IS NULL';

    this.ventrncotizacionService.encontrarGruNombre(this.types[0].value +
      ' LIKE \'' + parametro + '\'').subscribe(eR => {
        if (eR !== null) {
          if (eR[0] !== undefined) {
            this.ventrncotizacionService.trncotiza[this.indicador].GRUP_CODIGO = parametro;
            this.ventrncotizacionService.trncotiza[this.indicador].GRUP_NOMBRE = eR[0].GRUP_NOMBRE;
            this.cambio(true);
            
          } else {
            this.busqService.busquedaInvMaeGrupo1('GRUP_CODIGOP IS NULL').subscribe((datos: any[]) => {
              this.arregloCons = datos;
              this.displayDialogBusquedaFast = true;
            });
          }
        } else {
          this.busqService.busquedaInvMaeGrupo1('GRUP_CODIGOP IS NULL').subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.displayDialogBusquedaFast = true;
          });
        }
      });
  }
  manejarSeleccion(opcion){
    if (this.opcionbusqueda === 'cliente') {
      this.ventrncotizacionService.trncotiza[this.indicador].CLI_CODIGO = opcion.CLI_CODIGO;
      this.ventrncotizacionService.trncotiza[this.indicador].CLI_NOMBRE = opcion.CLI_NOMBRE;
      document.getElementById('VEN_CODIGO').focus();
    }
    if (this.opcionbusqueda === 'vendedor') {
      this.ventrncotizacionService.trncotiza[this.indicador].VEN_CODIGO = opcion.VEN_CODIGO;
      this.ventrncotizacionService.trncotiza[this.indicador].VEN_NOMBRE = opcion.VEN_NOMBRE;
      document.getElementById('GRUP_CODIGO').focus();
    }
    if (this.opcionbusqueda === 'busquedagrupo') {
      this.ventrncotizacionService.trncotiza[this.indicador].GRUP_CODIGO = opcion.GRUP_CODIGO;
      this.ventrncotizacionService.trncotiza[this.indicador].GRUP_NOMBRE = opcion.GRUP_NOMBRE;
     
    }
    this.displayDialogBusquedaFast=false
  }
}
